import * as getter from '../types/getters'
import * as action from '../types/actions'
import linq from 'linq'
import { classValidate } from '../../utility/validateUtility'
import Form from 'vform'
import Paginate from '../../models/Paginate'
import { buildQuery } from '../../utility/stringUtility'
import store from '../../store'
import User from '../../models/User'
import UserDeliveryAddress from '../../models/UserDeliveryAddress'

export const state = {
    list: [],
    user: new User(),
    paginate: new Paginate(),
    userTypeList: [],
}

export const mutations = {
    [action.FETCH_USERS](state, list) {
        state.list = list
    },

    [action.FETCH_USER](state, user) {
        state.user = user
    },

    [action.UPDATE_USERS_PAGINATE](state, paginate) {
        state.paginate = new Paginate(paginate)
    },

    [action.UPDATE_USER_ADDRESSES](state, user) {
        state.user = user
    },

    [action.UPDATE_USER](state, user) {
        state.user = user
    },

    [action.UPDATE_USER_TYPE_LIST](state, list) {
        state.userTypeList = list
    },
}

export const actions = {
    async [action.FETCH_USERS]({ commit }) {
        const query = buildQuery(store.state.route.query)
        const { data } = await axios.get(`/api/users?${query}`)
        const list = linq
            .from(data.data)
            .select((x) => new User(x))
            .toArray()
        commit(action.FETCH_USERS, list)
        commit(action.UPDATE_USERS_PAGINATE, data)
    },

    async [action.FETCH_USER]({ commit }) {
        const id = `/${store.state.route.params.id}` || null
        const { data } = await axios.get(`/api/user${id}`)
        console.log(data)
        const user = new User(data.user)
        const userTypeList = data.user_type_list.map((x, key) => {
            return { name: x, value: Number(key) }
        })
        
        // ユーザー区分並び替え
        const order = [
            '社内', 
            '一般ユーザー', 
            '契約前ユーザー', 
            '契約ユーザー(定価)',
            '契約ユーザー（10％割引）',
            '契約ユーザー（20%割引）',
            '契約ユーザー（30%割引）',
            '契約ユーザー（40%割引）',
            '契約ユーザー（50%割引）',
            '契約ユーザー（テーブルクロス50%:その他30％割引）',
            '契約ユーザー（リネン10%:その他割引なし）',
            '契約ユーザー（リネン20%:その他10％割引）',
            '契約ユーザー（リネン30%:その他20％割引）',
            '契約ユーザー（リネン40%:その他30％割引）',
        ]
        const sorted = userTypeList.sort((a, b) => {
            return order.indexOf(a.name) - order.indexOf(b.name)
        })
        commit(action.FETCH_USER, user)
        commit(action.UPDATE_USER_TYPE_LIST, sorted)
    },

    async [action.UPDATE_USER_ADDRESSES]({ commit }, user) {
        // const { data } = await user.patch(`/api/mypage/user/change-address/${user.id}`)
        // user.deliveryAddresses = linq.from(data).select( x => new UserDeliveryAddress(x)).toArray()
        commit(action.UPDATE_USER_ADDRESSES, user)
    },

    async [action.UPDATE_USER]({ commit }, user) {
        const { data } = await user.patch(`/api/user/${user.id}`)
        commit(action.UPDATE_USER, user)
    },
}

export const getters = {
    [getter.USERS]: (state) => state.list,
    [getter.USER]: (state) => state.user,
    [getter.USERS_PAGINATE]: (state) => state.paginate,
    [getter.USER_ADDRESSES]: (state) => state.user,
    [getter.USER_TYPE_LIST]: (state) => state.userTypeList,
}

export default {
    state,
    mutations,
    actions,
    getters,
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/users.js